import * as ActionTypes from "constants/ActionTypes";

function playerOptions(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SET_PLAYER_OPTIONS:
      return action.playerOptions;
    default:
      return state;
  }
}

export default playerOptions;
